module.exports = __webpack_public_path__ + "static/media/book_group_card.5847ac05.png";